import config from './config';
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import { Button, Chip, Paper, Typography } from "@mui/material";
import { useContext, useState, useEffect } from "react";
import { AppContext } from "./App";
import BarraFinal from "./componentes/BarraFinal";
import tile_perfil from "./images/tile_perfil.svg";
import tile_aplicar from "./images/tile_aplicar.svg";
import tile_chat from "./images/tile_chat.svg";
import tile_plan from "./images/tile_plan.svg";
import tile_referir from "./images/tile_referir.svg";
import tile_historial from "./images/tile_historial.svg";
import { Link } from "react-router-dom";
import BarraApp from "./componentes/BarraApp.js";
import ModalDatosFaltantes from "./componentes/ModalDatosFaltantes";
import axios from "axios";
import numeral from "numeral";
import moment from "moment";
import { orange } from "@mui/material/colors";

const feriadosSinServicio = {
  "2026-10-07": { nombre: "Morazánico", desde: "12:00" },
  "2026-10-08": { nombre: "Morazánico" },
  "2026-10-09": { nombre: "Morazánico" }
};

const obtenerFechaHonduras = () => {
  return new Date(new Date().toLocaleString("en-US", {
    timeZone: "America/Tegucigalpa"
  }));
};

const obtenerClaveFecha = fecha => `${fecha.getFullYear()}-${String(fecha.getMonth() + 1).padStart(2, '0')}-${String(fecha.getDate()).padStart(2, '0')}`;

const obtenerMensajeCierre = (claveFecha, esFinDeSemana, esFeriado) => {
  const feriado = feriadosSinServicio[claveFecha];
  if (feriado && esFeriado) {
    const inicio = feriado.desde ? ` desde las ${feriado.desde} (hora de Honduras)` : '';
    return `Por motivo del Feriado ${feriado.nombre}, hoy no se procesan solicitudes ni desembolsos de préstamos${inicio}.`;
  }
  return esFinDeSemana ? "Te recordamos que los fines de semana no se realizan solicitudes ni desembolsos de préstamos." : "";
};

function Main() {
  const gContext = useContext(AppContext);
  const [showAplicarLink, setShowAplicarLink] = useState(false);
  const [ubicacion, setUbicacion] = useState('');
  const [cargandoUbicacion, setCargandoUbicacion] = useState(false);
  const [loading, setLoading] = useState(true);
  const [aplicando, setAplicando] = useState(false);
  const [usuarioDetalle, set_usuarioDetalle] = useState({});
  const [usuarioDetalleFullR, set_usuarioDetalleFullR] = useState(false);
  const [faltaTerminarRegistro, set_faltaTerminarRegistro] = useState(false);
  const [cargando, set_cargando] = useState(true);
  const [cargando2, set_cargando2] = useState(true);
  const [openterminarreg, set_openterminarreg] = useState(false);
  const [openEditarCampos, set_openEditarCampos] = useState(false);
  const [walletData, set_walletData] = useState(false);
  const [moduloEditarActivo, set_moduloEditarActivo] = useState("");
  const [clasificacion, set_clasificacion] = useState("--");
  const [apiCamposConstructor, set_apiCamposConstructor] = useState(false);
  const [usuarioFiles, set_usuarioFiles] = useState(false);
  const [usuarioAprobadoManual, set_usuarioAprobadoManual] = useState(false);
  const [urlImagenPerfilTerminada, set_urlImagenPerfilTerminada] = useState(false);
  const [datosEnviadosArevision, set_datosEnviadosArevision] = useState(false);
  const [actualizacionHorario, setActualizacionHorario] = useState(0);
  const [prestamoActivo, set_prestamoActivo] = useState(null);
  const [proximaCuota, set_proximaCuota] = useState(null);
  const [fechaFinalPrestamo, set_fechaFinalPrestamo] = useState(null);

  useEffect(() => {
    if (String(usuarioDetalle.state) !== "1" || !gContext.logeado?.token) return;
    const sid = gContext.logeado.token;
    let cancelado = false;
    axios.post(`${config.apiUrl}/api/app/getCustomerOfferList.php`, { sid }).then(res => {
      if (cancelado || res.data.status !== "OK") return;
      const prestamo = Object.values(res.data.payload || {}).find(p => [1, 3, 5, 8].includes(p.status));
      if (!prestamo) return;
      set_prestamoActivo(prestamo);
      axios.post(`${config.apiUrl}/api/app/getWalletInfo.php`, { sid }).then(w => {
        if (!cancelado && w.data.status === "OK") set_walletData(w.data.payload.data);
      }).catch(() => {});
      return axios.post(`${config.apiUrl}/api/app/getBorrowerRepaymentSchedule.php`, { sid, ContainerId: prestamo.container_id }).then(r => {
        if (cancelado || r.data.status !== "OK") return;
        const v = x => Number(x || 0);
        const cuotas = Object.values(r.data.payload || {});
        if (cuotas.length) {
          set_fechaFinalPrestamo(cuotas.reduce((max, c) => moment(c.schedule_date).isAfter(max) ? moment(c.schedule_date) : max, moment(cuotas[0].schedule_date)));
        }
        const pendientes = cuotas.filter(p => ![1, 6].includes(parseInt(p.status, 10))).sort((a, b) => new Date(a.schedule_date) - new Date(b.schedule_date));
        const p = pendientes[0];
        if (!p) return;
        set_proximaCuota({
          fecha: p.schedule_date,
          monto: v(p.charge) - v(p.charge_covered) + v(p.administrator_fee) - v(p.administrator_fee_covered) + v(p.amount) - v(p.amount_covered) + v(p.late_fee) - v(p.cinterest_covered)
        });
      });
    }).catch(() => {});
    return () => {
      cancelado = true;
    };
  }, [usuarioDetalle.state, gContext.logeado?.token]);

  //aviso inicio//

  //aviso final//

  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);
    }, 2000);
    return () => clearTimeout(timer);
  }, []);
  function validarPerfilEnCore(callback) {
    // Para saber si ya está registrado en el CORE o no
    axios.request({
      url: `${config.apiUrl}/api/app/getProfile.php`,
      method: "post",
      data: {
        sid: gContext.logeado?.token
      }
    }).then(res => {
      set_cargando(false);
      if (res.data.status === "ER") {}
      if (res.data.status === "ERS") {
        localStorage.removeItem('arani_session_id');
        gContext.set_logeado({
          estado: false,
          token: ''
        });
      }
      if (res.data.status === "OK") {
        set_usuarioDetalleFullR(res.data);
        set_usuarioDetalle(res.data.payload.data);
        set_usuarioFiles(res.data.files);
        set_clasificacion(res.data.csas);
        if (res.data.payload.data.status === "1") {
          set_usuarioAprobadoManual(true);
        }
        if (res.data.datasend === "CMP") {
          set_datosEnviadosArevision(true);
        }

        // Imagen perfil
        let t18 = res.data.files.find(e => e.type === "18");
        if (t18?.dir) set_urlImagenPerfilTerminada(`${config.apiUrl}${t18?.dir}`);

        // Obtener customer_id y person_code
        const customerId = res.data.payload.data.customer_id;
        const personCode = res.data.payload.data.person_code;

        // Llama a la función para guardar la ubicación
        guardarUbicacion(customerId, personCode);
      }
      if (res.data.status === 500) {
        set_faltaTerminarRegistro(true);
      }
      if (typeof callback === 'function') callback();
    }).catch(err => {});
  }
  async function guardarUbicacion(customerId, personCode) {
    // Mostrar "Cargando ubicación..." inmediatamente
    setCargandoUbicacion(true);
    setUbicacion('Cargando ubicación...');

    // Flag local para rastrear si la ubicación fue obtenida
    let ubicacionObtenida = false;

    // Crear un timeout de 30 segundos para mostrar error si no obtiene ubicación
    const timeoutId = setTimeout(() => {
      if (!ubicacionObtenida) {
        setCargandoUbicacion(false);
        setUbicacion('No se pudo encontrar la ubicación. Por favor, verifica que tu navegador tenga permisos de geolocalización.');
      }
    }, 30000);

    // Success handler
    const onSuccess = async (position) => {
      ubicacionObtenida = true;
      clearTimeout(timeoutId);
      try {
        const { latitude, longitude } = position.coords;
        const apiUrl = `https://nominatim.openstreetmap.org/reverse?format=json&lat=${latitude}&lon=${longitude}&accept-language=es`;
        
        const response = await fetch(apiUrl);
        const data = await response.json();
        const normalizarTexto = (valor = '') => valor.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().trim();
        const address = data.address || {};
        const localidadCruda = address.city || address.town || address.village || address.municipality || address.county || address.suburb || address.neighbourhood || '';
        const localidadCrudaNormalizada = normalizarTexto(localidadCruda);

        // Nominatim a veces retorna zonas (ej. "Centro Historico de Tegucigalpa y Comayaguela")
        // en lugar del municipio, por lo que se mapea a una ciudad permitida.
        let ciudad = localidadCruda;
        if (localidadCrudaNormalizada.includes('tegucigalpa')) {
          ciudad = 'Tegucigalpa';
        } else if (localidadCrudaNormalizada.includes('comayaguela')) {
          ciudad = 'Comayagüela';
        }
        const pais = address.country || '';
        const ubicacionTexto = `${ciudad}, ${pais}`;
        setUbicacion(ubicacionTexto);

        // Lista de ubicaciones permitidas
        const ubicacionesPermitidas = ["Tegucigalpa, Honduras", "Comayagüela, Honduras", "Valle de Angeles, Honduras", "Choloma, Honduras", "La Lima, Honduras", "Villanueva, Honduras", "El Progreso, Honduras", "San Pedro Sula, Honduras", "Puerto Cortés, Honduras", "El Progreso, Honduras", "Danlí, Honduras", "Danlì, Honduras", "Danli, Honduras", "Choluteca, Honduras", "Comayagua, Honduras", "Siguatepeque, Honduras", "La Ceiba, Honduras", "La Paz, Honduras", "Santa Rosa de Copán, Honduras", "Gracias, Honduras", "Roatán, Honduras", "French Harbour, Honduras", "Santa Rosa, Honduras","Tela, Honduras" ,"Intibucá, Honduras" ];
        const ubicacionesPermitidasNormalizadas = ubicacionesPermitidas.map(normalizarTexto);
        const ubicacionTextoNormalizada = normalizarTexto(ubicacionTexto);

        // Verificar si la ubicación coincide con alguna de las ubicaciones permitidas
        if (ubicacionesPermitidasNormalizadas.includes(ubicacionTextoNormalizada)) {
          setShowAplicarLink(true);
        }

        // Obtener la dirección IP del dispositivo
        const ipResponse = await fetch('https://api.ipify.org?format=json');
        const ipData = await ipResponse.json();
        const ip = ipData.ip; // Capturando la IP

        // Obtener el navegador y sistema operativo
        const userAgent = navigator.userAgent;
        let navegador = 'Desconocido';
        let sistemaOperativo = 'Desconocido';
        if (userAgent.includes('Brave')) {
          navegador = 'Brave Browser';
        } else if (userAgent.includes('Chrome') && !userAgent.includes('Edg')) {
          navegador = 'Google Chrome';
        } else if (userAgent.includes('Firefox')) {
          navegador = 'Mozilla Firefox';
        } else if (userAgent.includes('Safari') && !userAgent.includes('Chrome')) {
          navegador = 'Apple Safari';
        } else if (userAgent.includes('Edg')) {
          navegador = 'Microsoft Edge';
        } else if (userAgent.includes('Opera') || userAgent.includes('OPR')) {
          navegador = 'Opera';
        } else if (userAgent.includes('MSIE') || userAgent.includes('Trident')) {
          navegador = 'Internet Explorer';
        }
        if (userAgent.includes('Macintosh') || userAgent.includes('Mac OS X')) {
          sistemaOperativo = 'MacOS';
        } else if (userAgent.includes('Win')) {
          sistemaOperativo = 'Windows';
        } else if (userAgent.includes('Linux') || userAgent.includes('X11')) {
          sistemaOperativo = 'Linux';
        } else if (userAgent.includes('Android')) {
          sistemaOperativo = 'Android';
        } else if (userAgent.includes('iPhone') || userAgent.includes('iPad')) {
          sistemaOperativo = 'iOS';
        }

        // Hacer POST a tu API para guardar latitud, longitud, navegador y sistema operativo
        const postResponse = await fetch('https://app.aranih.com/api/app/post_locations.php', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            idClient: customerId,
            ip: ip,
            latitude: latitude,
            longitude: longitude,
            navegador: navegador,
            sistema_operativo: sistemaOperativo
          })
        });

        // Verificar el estado de la respuesta
        if (!postResponse.ok) {
          const errorMessage = await postResponse.text();
          console.error('Error en la respuesta del API:', errorMessage);
          throw new Error(`HTTP error! status: ${postResponse.status}`);
        }

        // Intentar analizar la respuesta como JSON
        const postData = await postResponse.json();
        setCargandoUbicacion(false);
      } catch (error) {
        ubicacionObtenida = true;
        clearTimeout(timeoutId);
        setCargandoUbicacion(false);
        console.error('Error al guardar ubicación:', error);
        setUbicacion('No se pudo encontrar la ubicación. Por favor, verifica que tu navegador tenga permisos de geolocalización.');
      }
    };

    // Error handler
    const onError = (error) => {
      ubicacionObtenida = true;
      clearTimeout(timeoutId);
      setCargandoUbicacion(false);
      console.error('Error de geolocalización:', error);
      const errorMessages = {
        1: 'Permiso denegado. Por favor, habilita la geolocalización en tu navegador.',
        2: 'No se pudo obtener la posición. Por favor, intenta de nuevo.',
        3: 'La solicitud de geolocalización tardó demasiado. Por favor, intenta de nuevo.'
      };
      setUbicacion(errorMessages[error.code] || 'No se pudo encontrar la ubicación. Por favor, verifica que tu navegador tenga permisos de geolocalización.');
    };

    // Llamar a getCurrentPosition con ambos handlers
    navigator.geolocation.getCurrentPosition(onSuccess, onError, {
      timeout: 30000, // 30 segundos de timeout
      enableHighAccuracy: false
    });
  }

  // useEffect para llamar a la función validarPerfilEnCore al cargar el componente
  useEffect(() => {
    validarPerfilEnCore(() => {});
  }, []);

  const salir = () => {
    gContext.set_logeado({
      estado: false,
      token: ''
    });
    localStorage.removeItem('arani_session_id');
  };

  const abrirLandBot = async () => {
    try {
      const landbot = await window.initLandbot();
      landbot.open();
    } catch (error) {
      console.error('No se pudo abrir el chat:', error);
    }
  };

  const mensajesErrores = {
    0: "Vas muy bien! Ya pasaste a la segunda etapa",
    1: "No pudimos confirmar tu foto selfie en tu perfil. Para más detalles, <a href='https://www.arani.hn/erroresperfil.php' target='_blank'>haz clic aquí</a>.",
    2: "Tu recibo público no es válido en tu perfil. Para más detalles, <a href='https://www.arani.hn/erroresperfil.php' target='_blank'>haz clic aquí</a>.",
    3: "No pudimos confirmar tus documentos en tu perfil. Para más detalles, <a href='https://www.arani.hn/erroresperfil.php' target='_blank'>haz clic aquí</a>.",
    4: "No pudimos confirmar tu DNI en tu perfil. Para más detalles, <a href='https://www.arani.hn/erroresperfil.php' target='_blank'>haz clic aquí</a>.",
    5: "Por ahora no fue posible aprobar tu préstamo tras el analisis de tu perfil. Tu situación puede mejorar con el tiempo, por lo que te invitamos a volver a intentarlo en 6 meses para una nueva evaluación. Para más detalles, <a href='https://www.arani.hn/erroresperfil.php' target='_blank'>haz clic aquí</a>.",
    7: "Por ahora no fue posible aprobar tu préstamo tras el analisis de tu perfil. Tu situación puede mejorar con el tiempo, por lo que te invitamos a volver a intentarlo en 6 meses para una nueva evaluación. Para más detalles, <a href='https://www.arani.hn/erroresperfil.php' target='_blank'>haz clic aquí</a>.",
    8: "Por ahora no fue posible aprobar tu préstamo tras el analisis de tu perfil. Tu situación puede mejorar con el tiempo, por lo que te invitamos a volver a intentarlo en 6 meses para una nueva evaluación. Para más detalles, <a href='https://www.arani.hn/erroresperfil.php' target='_blank'>haz clic aquí</a>.",
    9: "Por ahora no fue posible aprobar tu préstamo tras el analisis de tu perfil. Tu situación puede mejorar con el tiempo, por lo que te invitamos a volver a intentarlo en 6 meses para una nueva evaluación. Para más detalles, <a href='https://www.arani.hn/erroresperfil.php' target='_blank'>haz clic aquí</a>.",
    10: "Por ahora no fue posible aprobar tu préstamo tras el analisis de tu perfil. Tu situación puede mejorar con el tiempo, por lo que te invitamos a volver a intentarlo en 6 meses para una nueva evaluación. Para más detalles, <a href='https://www.arani.hn/erroresperfil.php' target='_blank'>haz clic aquí</a>.",
    11: "Por ahora no fue posible aprobar tu préstamo tras el analisis de tu perfil. Tu situación puede mejorar con el tiempo, por lo que te invitamos a volver a intentarlo en 6 meses para una nueva evaluación. Para más detalles, <a href='https://www.arani.hn/erroresperfil.php' target='_blank'>haz clic aquí</a>.",
    12: "Por ahora no fue posible aprobar tu préstamo tras el analisis de tu perfil. Tu situación puede mejorar con el tiempo, por lo que te invitamos a volver a intentarlo en 6 meses para una nueva evaluación. Para más detalles, <a href='https://www.arani.hn/erroresperfil.php' target='_blank'>haz clic aquí</a>.",
    13: "Faltan documentos requeridos. Para más detalles, <a href='https://www.arani.hn/erroresperfil.php' target='_blank'>haz clic aquí</a>.",
    14: "Validación de fotografía selfie fallida. Para más detalles, <a href='https://www.arani.hn/erroresperfil.php' target='_blank'>haz clic aquí</a>.",
    15: "Recibo público no es válido. Para más detalles, <a href='https://www.arani.hn/erroresperfil.php' target='_blank'>haz clic aquí</a>.",
    16: "Recibo público mayor al tiempo permitido. Para más detalles, <a href='https://www.arani.hn/erroresperfil.php' target='_blank'>haz clic aquí</a>.",
    17: "Referencias no son validas. Para más detalles, <a href='https://www.arani.hn/erroresperfil.php' target='_blank'>haz clic aquí</a>.",
    18: "No pudimos validar tu identidad. Para más detalles, <a href='https://www.arani.hn/erroresperfil.php' target='_blank'>haz clic aquí</a>.",
    19: "Cuenta de banco no es valida, Para más detalles, <a href='https://www.arani.hn/erroresperfil.php' target='_blank'>haz clic aquí</a>.",
    21: "Solicitud no aprobada por ahora no fue posible aprobar tu préstamo tras el análisis de tu perfil. Tu situación puede mejorar con el tiempo, por lo que te invitamos a volver a intentarlo en 6 meses para una nueva evaluación.",
    22: "Solicitud no aprobada por ahora no fue posible aprobar tu préstamo tras el análisis de tu perfil. Tu situación puede mejorar con el tiempo, por lo que te invitamos a volver a intentarlo en 6 meses para una nueva evaluación.",
    23: "Solicitud no aprobada por ahora no fue posible aprobar tu préstamo tras el análisis de tu perfil. Tu situación puede mejorar con el tiempo, por lo que te invitamos a volver a intentarlo en 6 meses para una nueva evaluación."
  };
  const styles = {
    container: {
      padding: '16px',
      margin: '16px auto',
      maxWidth: '500px',
      backgroundColor: '#fff5f5',
      border: '1px solid #f5c2c2',
      borderRadius: '8px',
      textAlign: 'center',
      boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)'
    },
    text: {
      color: '#e74c3c',
      fontSize: '16px',
      fontWeight: 'bold',
      lineHeight: '1.5'
    },
    containerOk: {
      padding: '16px',
      margin: '16px auto',
      maxWidth: '500px',
      backgroundColor: '#f0fff4',
      border: '1px solid #b7ebc6',
      borderRadius: '8px',
      textAlign: 'center',
      boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)'
    },
    textOk: {
      color: '#5b75e7',
      fontSize: '16px',
      fontWeight: 'bold',
      lineHeight: '1.5'
    },
    linkOk: {
      color: orange[700],
      textDecoration: 'underline'
    }
  };
  const [showModal, setShowModal] = useState(false);
  const handleSaveDatosFaltantes = formData => {
    // Aquí puedes enviar los datos al backend o actualizar el estado

    setShowModal(false);
  };
  const fechaActualHonduras = obtenerFechaHonduras();
  const fechaHoyHonduras = obtenerClaveFecha(fechaActualHonduras);
  const esFinDeSemana = fechaActualHonduras.getDay() === 0 || fechaActualHonduras.getDay() === 6;
  const feriadoHoy = feriadosSinServicio[fechaHoyHonduras];
  const minutosActuales = fechaActualHonduras.getHours() * 60 + fechaActualHonduras.getMinutes();
  const [horaInicioFeriado, minutoInicioFeriado] = (feriadoHoy?.desde || "00:00").split(":").map(Number);
  const esFeriado = Boolean(feriadoHoy) && minutosActuales >= horaInicioFeriado * 60 + minutoInicioFeriado;
  const esDiaSinServicio = esFinDeSemana || esFeriado;
  const mensajeCierreHoy = obtenerMensajeCierre(fechaHoyHonduras, esFinDeSemana, esFeriado);
  useEffect(() => {
    const proximaActualizacion = new Date(fechaActualHonduras);
    proximaActualizacion.setHours(24, 0, 0, 0);

    if (feriadoHoy?.desde) {
      const fechaInicioFeriado = new Date(fechaActualHonduras);
      fechaInicioFeriado.setHours(horaInicioFeriado, minutoInicioFeriado, 0, 0);
      if (fechaInicioFeriado > fechaActualHonduras && fechaInicioFeriado < proximaActualizacion) {
        proximaActualizacion.setTime(fechaInicioFeriado.getTime());
      }
    }

    const timer = setTimeout(() => setActualizacionHorario(Date.now()), proximaActualizacion.getTime() - fechaActualHonduras.getTime());
    return () => clearTimeout(timer);
  }, [actualizacionHorario, fechaHoyHonduras, feriadoHoy?.desde, horaInicioFeriado, minutoInicioFeriado]);
  return <Container disableGutters sx={{
    minHeight: '100vh',
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center"
  }} component="main" maxWidth="md">
            {aplicando && <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      zIndex: 2000,
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      backgroundColor: '#5b75e7',
      color: '#fff'
    }}>
                    <img src={process.env.PUBLIC_URL + '/araniloader1.gif'} alt="loading" style={{
        height: '200px',
        width: '200px'
      }} />
                    <Typography variant="h6" sx={{
        color: '#fff',
        textAlign: 'center',
        px: 2
      }}>Procesando tu solicitud, por favor espera...</Typography>
                  </div>}
            {loading ? <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      backgroundColor: '#5b75e7'
    }}>
                    <img src={process.env.PUBLIC_URL + '/araniloader1.gif'} alt="loading" style={{
        height: '250px',
        width: '250px'
      }} />
                  </div> : <Box sx={{
      p: '4px'
    }}>
                <Paper elevation={6} sx={{
        p: 6
      }}>
                    <BarraApp />
                    <Typography variant="h5" sx={{
          mt: 6
        }}>Inicio</Typography>
                    <p>
                        <strong>Ubicación: </strong> 
                        {loading ? 'Cargando...' : <span style={{
            color: ubicacion === 'Para continuar con el proceso de solicitud de préstamo en Arani App, es necesario que el navegador acceda a tu ubicación en tu celular.' ? 'red' : 'black'
          }}>
                                {ubicacion}
                                {ubicacion === 'Para continuar con el proceso de solicitud de préstamo en Arani App, es necesario que el navegador acceda a tu ubicación en tu celular.' && <a href="https://www.arani.hn/erroresperfil.php#ubicacion" target="_blank" rel="noopener noreferrer" style={{
              marginLeft: '8px',
              color: 'blue'
            }}>
                                        Ver más
                                    </a>}
                            </span>}
                    </p>
                    {usuarioDetalle.status === "1" && !showAplicarLink && ubicacion !== "Para continuar con el proceso de solicitud de préstamo en Arani App, es necesario que el navegador acceda a tu ubicación en tu celular." && <div style={{
          color: "#e74c3c",
          fontWeight: "bold",
          marginBottom: 16
        }}>
                            Lo sentimos, actualmente esta función no está permitida en tu ubicación.
                        </div>}

                    {(usuarioDetalle.status === "0" || usuarioDetalle.status === 0) && <>
                            {(() => {
            const errorPerfil = usuarioDetalle.errores_perfil;
            const errorKey = errorPerfil != null && String(errorPerfil).trim() !== "" ? String(errorPerfil) : "0";

            // Si errores_perfil está vacío/null/undefined se trata como "0" (mensaje verde).
            if (errorKey !== "20") {
              // Caso especial: errores_perfil = 0 (mostrar en verde + link interno)
              if (errorKey === "0") {
                return <div style={styles.containerOk}>
                                                <Typography style={styles.textOk}>
                                                    {mensajesErrores[0]}
                                                    <span> 🎉</span>
                                                    <br />
                                                    Estás a un paso de solicitar tu préstamo.
                                                    <br />
                                                    <br />
                                                    Completa tu perfil ahora y desbloquea tu monto disponible en unos minutos.
                                                    <br />
                                                    <Link to="/perfil" style={styles.linkOk}>Completar mi perfil</Link>
                                                </Typography>
                                            </div>;
              }

              // Resto de errores (mantener estilo rojo)
              return <div style={styles.container}>
                                            <Typography style={styles.text} dangerouslySetInnerHTML={{
                  __html: mensajesErrores[errorKey] || errorPerfil
                }} />

                                        </div>;
            }

            // Si no hay error o la fecha no es un día antes, muestra el mensaje normal
            return <div style={styles.container}>
                                        <Typography style={styles.text}>
                                            Hemos recibido los cambios y estamos validando tus datos. Te estaremos respondiendo dentro de 48 horas hábiles, gracias por tu paciencia!
                                        </Typography>
                                        <Typography style={{
                ...styles.text,
                marginTop: '8px'
              }}>
                                            <a href="https://app.arani.hn/#/perfil" target="_blank" rel="noopener noreferrer" style={{
                  color: '#3498db',
                  textDecoration: 'none'
                }}>
                                                Ir a mi perfil
                                            </a>
                                        </Typography>
                                    </div>;
          })()}
                        </>}

                    {/* Anuncio para fechas especiales mostrar a todos los usuarios */}
                    {usuarioDetalle.status === "1" && esDiaSinServicio && <div style={styles.container}>
                      <Typography style={styles.text}>{mensajeCierreHoy}</Typography>
                      <Typography style={{ ...styles.text, marginTop: '8px' }}>
                        Gracias por tu comprensión.
                      </Typography>
                    </div>}
    

                    {String(usuarioDetalle.state) === "1" && prestamoActivo && Number(walletData?.amount_wallet_balance) >= Number(prestamoActivo.debt) && <div style={styles.containerOk}>
                        <Typography style={{
            ...styles.textOk,
            color: '#2e9e4f'
          }}>
                            Tu pago ya fue recibido y está pendiente de ser aplicado.
                            <br />
                            No tienes que hacer nada más, solo esperar la fecha de aplicación.
                            {fechaFinalPrestamo && <><br />Fecha final de tu préstamo: {fechaFinalPrestamo.format("LL")}</>}
                        </Typography>
                    </div>}

                    {String(usuarioDetalle.state) === "1" && prestamoActivo && !(Number(walletData?.amount_wallet_balance) >= Number(prestamoActivo.debt)) && <div className="bloqueprestamopdt" style={{
          padding: '2rem 1.5rem',
          marginBottom: '1rem'
        }}>
                        <span className="material-symbols-outlined iconodefondogrande">payments</span>
                        <div className="bloqueprestamopdt-tit">
                            <span>Tienes un préstamo activo · N.º {prestamoActivo.container_id}</span>
                            <h4 style={{
              paddingBottom: '1rem'
            }}><span>Lps. </span>{numeral(prestamoActivo.debt).format('0,0.00')}</h4>
                        </div>
                        {proximaCuota && <Box className="bloqueprestamopdt-dtll" sx={{
            position: 'relative',
            zIndex: 5
          }}>
                            <Chip size="small" variant="outlined" sx={{
              color: '#FFFFFF'
            }} label={"Próxima cuota: " + moment(proximaCuota.fecha).format("LL")} />
                            <Chip size="small" variant="outlined" sx={{
              color: '#FFFFFF'
            }} label={"Monto: Lps. " + numeral(proximaCuota.monto).format('0,0.00')} />
                        </Box>}
                        <Box sx={{
            position: 'relative',
            zIndex: 5,
            display: 'flex',
            justifyContent: 'center',
            mt: 2
          }}>
                            <Button component={Link} to="/plan" variant="contained" sx={{
              backgroundColor: '#EB9180',
              color: '#ffffff',
              fontWeight: 700,
              boxShadow: 'none',
              '&:hover': {
                backgroundColor: '#e07f6b',
                boxShadow: 'none'
              }
            }}>Pagar mi préstamo</Button>
                        </Box>
                    </div>}

                    <div className={`contetilebotonpri${String(usuarioDetalle.state) === "0" && String(usuarioDetalle.status) === "0" ? "" : String(usuarioDetalle.state) === "0" ? " state-cero" : String(usuarioDetalle.status) === "1" ? " aplicar-primero" : String(usuarioDetalle.status) === "0" ? " status-cero" : ""}`}>
                        {["21", "22", "23"].includes(usuarioDetalle?.errores_perfil) ? <Link to="#" className="tilebotonpri disabled" aria-disabled="true" tabIndex={-1} onClick={e => e.preventDefault()}>

                                <div className="tilebotonpri-tit">Perfil</div>
                                <div className="tilebotonpri-desc">Lo sentimos tu perfil no es elegible.</div>
                                <div className="tilebotonpri-icon"><img alt="" src={tile_perfil} /></div>
                            </Link> : <Link to="/perfil" className="tilebotonpri">
                                <div className="tilebotonpri-tit">Perfil</div>
                                <div className="tilebotonpri-desc">Actualiza todos los datos de tu cuenta.</div>
                                <div className="tilebotonpri-icon"><img alt="" src={tile_perfil} /></div>
                            </Link>}


                        {/* Si el usuario está en la ubicación deseada, muestra el enlace de aplicar */}
                        {(() => {
            if (esDiaSinServicio) {
              return <Link to="#" onClick={e => e.preventDefault()} aria-disabled="true" tabIndex={-1} className="tilebotonpri disabled" style={{
                display: 'flex',
                justifyContent: 'flex-start',
                alignItems: 'center',
                textAlign: 'left',
                overflow: 'hidden',
                whiteSpace: 'normal',
                wordWrap: 'break-word'
              }}>
                                    <div style={{
                  flex: 1
                }}>
                                        <div className="tilebotonpri-tit" style={{
                    textAlign: 'left'
                  }}>Aplicar</div>
                                        <div className="tilebotonpri-desc" style={{
                    textAlign: 'left'
                  }}>
                                            {mensajeCierreHoy}
                                        </div>
                                    </div>
                                    <div className="tilebotonpri-icon" style={{
                  marginLeft: '8px'
                }}>
                                        <img alt="" src={tile_aplicar} />
                                    </div>
                                </Link>;
            }

            // Si el status es "0", mostrar el botón pero deshabilitado
            if (usuarioDetalle.status === "0" || usuarioDetalle.status === 0) {
              return <Link className="tilebotonpri disabled" to="#" onClick={e => e.preventDefault()}>
                                        <div className="tilebotonpri-tit">Aplicar</div>
                                        <div className="tilebotonpri-desc">
                                            Tu perfil sigue en proceso de validación. No puedes aplicar aún.
                                        </div>
                                        <div className="tilebotonpri-estado"></div>
                                        <div className="tilebotonpri-icon"><img alt="" src={tile_aplicar} /></div>
                                    </Link>;
            }

            // Si el usuario está validado pero fuera de ubicación permitida
            if ((usuarioDetalle.status === "1" || usuarioDetalle.status === 1) && !showAplicarLink) {
              return <Link className="tilebotonpri disabled">
                                        <div className="tilebotonpri-tit">Aplicar</div>
                                        <div className="tilebotonpri-desc">
                                            Lo sentimos, actualmente esta función no está permitida en tu ubicación.
                                        </div>
                                        <div className="tilebotonpri-estado"></div>
                                        <div className="tilebotonpri-icon"><img alt="" src={tile_aplicar} /></div>
                                    </Link>;
            }

            // Caso normal
            return showAplicarLink ? <Link to={!usuarioDetalle.ref_tipo_per || !usuarioDetalle.ref_nom_per || !usuarioDetalle.ref_tel_per ? "#" : "/aplicar2"} className="tilebotonpri" onClick={async e => {
              if (!usuarioDetalle.ref_tipo_per || !usuarioDetalle.ref_nom_per || !usuarioDetalle.ref_tel_per || !usuarioDetalle.ref_tipo_lab || !usuarioDetalle.ref_nom_lab || !usuarioDetalle.ref_tel_lab) {
                e.preventDefault();
                setShowModal(true);
              } else {
                // IMPORTANTE: detener navegación automática hasta tener respuesta
                e.preventDefault();
                if (aplicando) return;
                setAplicando(true);
                try {
                  // --- 1) Consultar tipo de cliente PRIMERO para obtener lastLoanDaysLate ---
                  const tipoClientePayload = {
                    customerId: String(usuarioDetalle.customer_id ?? ""),
                    token: "I25WlOdFy0yayTP3FAJe6JQZTmidHJm5M711zTdCtihlkgl4ZcC0tfKqXXatKqbZ"
                  };
                  const tipoClienteResponse = await fetch("https://app.aranih.com/api/app/getTipoCliente.php", {
                    method: "POST",
                    headers: {
                      "Content-Type": "application/json"
                    },
                    body: JSON.stringify(tipoClientePayload)
                  });
                  if (!tipoClienteResponse.ok) {
                    const errText = await tipoClienteResponse.text();
                    console.error("[Aplicar] getTipoCliente -> ERROR:", errText);
                    return; // NO avanzar
                  }
                  const tipoClienteRaw = (await tipoClienteResponse.text()).trim();

                  // Intentar parsear como JSON para extraer lastLoanDaysLate
                  let tipoClienteParsed = tipoClienteRaw;
                  try {
                    tipoClienteParsed = JSON.parse(tipoClienteRaw);
                  } catch (e) {}

                  // Extraer lastLoanDaysLate de la respuesta
                  const lastLoanDaysLate = tipoClienteParsed && typeof tipoClienteParsed === 'object' ? Number(tipoClienteParsed.lastLoanDaysLate ?? 0) : 0;

                  // Determinar tipo de cliente para la redirección
                  let tipoClienteResult = typeof tipoClienteParsed === 'object' ? String(tipoClienteParsed.tipo ?? tipoClienteParsed).trim() : String(tipoClienteParsed).trim();

                  // --- 2) postPriceList (ahora con lastLoanDaysLate de getTipoCliente) ---
                  const tokenPriceList = "d4d0YcB89pFZB4qYQALfQiqpTGaDY4VrsZrFSy8OomiVfe2pbOxk9TxbTFOTULTJ";
                  const parseFechaSQL = value => {
                    if (!value) return null;
                    const raw = String(value).trim();

                    // Soporta: "YYYY-MM-DD" y "YYYY-MM-DD HH:mm:ss" (formato típico SQL)
                    // Safari suele fallar con el espacio; por eso se normaliza a ISO.
                    const soloFecha = raw.includes(" ") ? raw.split(" ")[0] : raw;
                    const iso = `${soloFecha}T00:00:00`;
                    const date = new Date(iso);
                    return Number.isNaN(date.getTime()) ? null : date;
                  };
                  const inicioWork = parseFechaSQL(usuarioDetalle.created);
                  const hoy = new Date();
                  const dias = inicioWork && !Number.isNaN(inicioWork.getTime()) ? Math.max(0, Math.floor((hoy.getTime() - inicioWork.getTime()) / (1000 * 60 * 60 * 24))) : 0;
                  const clientIdPriceList = usuarioDetalle.customerId ?? usuarioDetalle.customer_id; // por si viene con otro nombre
                  const identidad = usuarioDetalle.person_code;
                  const payloadPriceList = {
                    client_id: String(clientIdPriceList ?? ""),
                    identidad: String(identidad ?? ""),
                    token: tokenPriceList,
                    dias: dias,
                    salario: Number(usuarioDetalle.income ?? 0),
                    lastLoanDaysLate: lastLoanDaysLate
                  };
                  const priceListResponse = await fetch("https://app.aranih.com/api/DecisionRules/postPriceList.php", {
                    method: "POST",
                    headers: {
                      "Content-Type": "application/json"
                    },
                    body: JSON.stringify(payloadPriceList)
                  });
                  if (!priceListResponse.ok) {
                    const errText = await priceListResponse.text();
                    console.error("[Aplicar] postPriceList -> ERROR body:", errText);
                    return; // NO avanzar a /aplicar
                  } else {
                    const okText = await priceListResponse.text();
                  }

                  // --- 3) modeloClienteExistente ---
                  try {
                    const payloadModeloCliente = {
                      codigo: "f7a6d3b4-5c29-4e7f-92a4-28e5d39c3a8e",
                      clientId: usuarioDetalle.customer_id // Usar el clientId del usuario
                    };

                    // Enviar datos a la API
                    const response = await fetch("https://app.aranih.com/api/app/modeloClienteExistente.php", {
                      method: "POST",
                      headers: {
                        "Content-Type": "application/json"
                      },
                      body: JSON.stringify(payloadModeloCliente)
                    });
                    if (!response.ok) {
                      console.error("[Aplicar] modeloClienteExistente -> ERROR body:", await response.text());
                    } else {}
                  } catch (error) {
                    console.error("[Aplicar] modeloClienteExistente -> Error al realizar la solicitud:", error);
                  }

                  // --- 4) Redirigir según tipo de cliente ---
                  if (tipoClienteResult === "nuevo") {
                    window.location.hash = "#/aplicar";
                  } else {
                    window.location.hash = "#/aplicar2";
                  }
                } catch (error) {
                  console.error("[Aplicar] Error general (postPriceList/modeloClienteExistente):", error);
                  // NO avanzar a /aplicar2
                } finally {
                  setAplicando(false);
                  setLoading(false);
                }
              }
            }}>

                                    <div className="tilebotonpri-tit">Aplicar</div>
                                    <div className="tilebotonpri-desc">Formulario para solicitar préstamos.</div>
                                    <div className="tilebotonpri-estado"></div>
                                    <div className="tilebotonpri-icon"><img alt="" src={tile_aplicar} /></div>
                                </Link> : <Link className="tilebotonpri disabled">
                                    <div className="tilebotonpri-tit">Aplicar</div>
                                    <div className="tilebotonpri-desc">
                                        {ubicacion && ubicacion !== "Para continuar con el proceso de solicitud de préstamo en Arani App, es necesario que el navegador acceda a tu ubicación en tu celular." ? `Lo sentimos, esta opción no está disponible en ${ubicacion}` : "Lo sentimos es necesario que el navegador acceda a tu ubicación en tu celular."}
                                    </div>
                                    <div className="tilebotonpri-estado"></div>
                                    <div className="tilebotonpri-icon"><img alt="" src={tile_aplicar} /></div>
                                </Link>;
          })()}

                        <Link to="/plan" className="tilebotonpri">
                            <div className="tilebotonpri-tit">Plan</div>
                            <div className="tilebotonpri-desc">Calendarización de los pagos de tus préstamos</div>
                            <div className="tilebotonpri-estado"></div>
                            <div className="tilebotonpri-icon"><img alt="" src={tile_plan} /></div>
                        </Link>
                        
                        <Link to="/historial" className="tilebotonpri">
                            <div className="tilebotonpri-tit">Historial</div>
                            <div className="tilebotonpri-desc">Registro de la actividad en ARANI</div>
                            <div className="tilebotonpri-estado"></div>
                            <div className="tilebotonpri-icon"><img alt="" src={tile_historial} /></div>
                        </Link>
                        
                        

                        {/* Otros componentes Link aquí */}
                        {/* <div className="tilebotonpri" onClick={abrirLandBot}>
                            <div className="tilebotonpri-tit">Chat</div>
                            <div className="tilebotonpri-desc">Centro de ayuda de Arani.</div>
                            <div className="tilebotonpri-estado"></div>
                            <div className="tilebotonpri-icon"><img alt="" src={tile_chat} /></div>
                        </div> */}
                        {/* <div className="tilebotonpri disabled">
                            <div className="tilebotonpri-tit">Referir</div>
                            <div className="tilebotonpri-desc">Invita a personas y gana recompesas.</div>
                            <div className="tilebotonpri-estado"></div>
                            <div className="tilebotonpri-icon"><img alt="" src={tile_referir} /></div>
                        </div> */}
                    </div>
                    <Button onClick={salir} variant="contained" sx={{
          mt: 3
        }}>Cerrar sesión</Button>
                </Paper>
                <BarraFinal />
            </Box>}

            <ModalDatosFaltantes open={showModal} onClose={() => setShowModal(false)} onSave={handleSaveDatosFaltantes} />

        </Container>;
}
export default Main;
